const store = {
    namespaced: true,
    state: {
        pack_mode: {
            scanner_modes: [
                // "tally",
                "addition",
                "selection",
                "packing",
            ],
            current_scanner_mode: null,
            selected_pack: {},
            current_pack: {},
            packs: [],
            workspace_identity: null,
            workflows: [],
            is_processing: false,
        },
        unpack_mode: {
            scanner_modes: [
                "show",
                "unpacking",
            ],
            current_scanner_mode: null,
            current_pack: {},
            packs: [],
            workspace_identity: null,
            workflows: [],
        },
    },
    getters: {
    },
    mutations: {
    }
}

export default store
